<template>
<el-form  :rules="rules" ref="nbiotForm" :model="comms" label-width="50%" label-position="left">
    <el-form-item label="NbIoT name :" prop="name">
      <el-input style="width:70%" v-model="comms.name"/>
    </el-form-item>
    <el-form-item label="APN :" prop="apn">
      <el-input style="width:70%" v-model="comms.apn"/>
    </el-form-item>
    <el-form-item label="Band:" prop="band">
      <el-input v-model.number="comms.band" style="width:20%"/>
    </el-form-item>
    <el-form-item label="Operator :" prop="operator">
      <el-input style="width:70%" v-model="comms.operator"/>
    </el-form-item>
    <el-form-item label="Port :" prop="port">
      <el-input style="width:70%" v-model="comms.port"/>
    </el-form-item>
    <el-form-item label="Udp addesse :" prop="udp_addr">
      <el-input style="width:70%" v-model="comms.udp_addr"/>
    </el-form-item>
    <el-form-item label="Udp Port :" prop="port">
      <el-input v-model.number="comms.udp_port" style="width:20%"/>
    </el-form-item>
    
  </el-form>
</template>

<script>
import { post } from "../../../../../API/cloudFunctions";

export default {
  created() {
    if (this.$store.getters.smtpConfig) {
      this.smtp = this.$store.getters.smtpConfig;
    }
  },
  name: "nbiot",
  data() {
    return {
      comms: {
        name: "bc95",
        apn: "nb.inetd.gdsp",
        band: 20,
        operator: "27201",
        port: "/dev/ttyS4",
        udp_addr: "52.19.219.211",
        udp_port: 10000
      },
      rules: {
        name: {
          required: true,
          message: "Please provide a Name !"
        },
        apn: { required: true },
        band: { required: true },
        operator: { required: true },
        port: { required: true },
        udp_addr: { required: true },
        udp_port: { required: true }
      },
      loading: false,
      disablePassword: true,
      sendingTestEmail: false,
      sent: false
    };
  },
  methods: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/components/profile/configuration/nbiot.vue